import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    salesInvoices: [],
    salesInvoice: null,
    filteredSalesInvoices: [],
    isLoading: false,
    isUpdating: false,
    isUpdated: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function salesInvoiceReducer(state = initialState, action) {

    var newState;
    switch (action.type) {
        case Constants.REQUEST_GET_SALES_INVOICE:
            newState = {
                ...state,
                isLoading: true,
                isPosting: false,
                isPosted: false,
                error: null
            };

            return newState;
        case Constants.REQUEST_ADD_SALES_INVOICE:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;
        case Constants.SUCCESS_ADD_SALES_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            newState.salesInvoice = action.salesInvoice;
            return newState;
        case Constants.SUCCESS_FILTERED_SALES_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredSalesInvoices = action.filteredSalesInvoices;
            return newState;
        case Constants.FAILED_ADD_SALES_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_UPDATE_SALES_INVOICE:
            newState = {
                ...state,
                isUpdating: true
            }
            return newState;
        case Constants.SUCCESS_UPDATE_SALES_INVOICE:
            newState = { ...state };
            newState.isUpdating = false;
            newState.isUpdated = true;
            if (action.id) newState.salesInvoices = state.salesInvoices.filter(a => a.id !== action.id);
            return newState;

        case Constants.FAILED_UPDATE_SALES_INVOICE:
            newState = {
                ...state,
                isUpdating: false,
                error: action.error
            }
            return newState;

        case Constants.SUCCESS_GET_SALES_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            if (action.payload.items) {
                newState.salesInvoices = action.payload.items;
                newState.page = action.payload.page;
                newState.pageSize = action.payload.pageSize;
                newState.count = action.payload.totalCount;
            } else {
                newState.salesInvoice = action.payload;
            }

            return newState;

        case Constants.RESET_SALES_INVOICE:
            newState = {
                ...state,
                salesInvoices: [],
                salesInvoice: null,
                filteredSalesInvoices: [],
                isLoading: false,
                isUpdating: false,
                isUpdated: false,
                isPosting: false,
                isPosted: false,
                count: 0,
                page: 1,
                pageSize: 10,
                error: null
            };
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SalesInvoiceReducer.js